<template>
  <TransitionRoot as="template" :show="show_auth_error">
    <Dialog as="div" class="fixed inset-0 z-10 overflow-y-auto" @close="show_auth_error = false">
      <div class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
            class="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div class="sm:flex sm:items-start">
              <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                <TriangleAlert class="w-6 h-6 text-red-600" aria-hidden="true" />
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                  {{ $t("Something went wrong!") }}
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-base text-gray-700">
                    {{ error }}
                  </p>
                  <p class="text-sm text-gray-500">
                    {{ error_description }}
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                ref="cancelButtonRef"
                type="button"
                class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                @click="
                  () => {
                    $router.push('/admin/integrations/')
                    show_auth_error = false
                  }
                ">
                {{ $t("Retry again") }}
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import IntegrationService from "@/services/integration.service"
import { TriangleAlert } from "lucide-vue-next"

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue"
import { utils } from "@/store/helpers"
export default {
  name: "Callback",

  components: {
    TriangleAlert,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot
  },
  data() {
    return {
      error: "",
      error_description: "",
      show_auth_error: false
    }
  },

  created() {
    this.$store.dispatch("ui/showLoading")

    if (this.$store.state.auth.status.isLoggedIn) {
      // if (document.referrer || this.$route.query.instance_url) {
      let code = this.$route.query.code
      let integration_name = this.$route.params?.integration_name
      // get next route from query state after converting it to string from base64
      let next = "/admin/integrations"
      let integration_id = integration_name
      let org_id = this.$store.state.organization.id

      if (utils.isNotEmpty(this.$route.query.state)) {
        let extra_data = JSON.parse(atob(this.$route.query.state))
        next = extra_data?.["next"] || next
        integration_id = extra_data?.["integration_id"] || integration_name
        org_id = org_id || extra_data?.["org_id"]
      }

      if (utils.isNotEmpty(code)) {
        let instance_url = document.referrer ? document.referrer : this.$route.query.instance_url
        let data = { auth_code: code, instance_url: instance_url }
        if (integration_name == "outlook") {
          data["code_verifier"] = localStorage.getItem("code_verifier")
          data["scope"] = localStorage.getItem("scope")
          localStorage.removeItem("code_verifier")
          localStorage.removeItem("scope")
        }

        IntegrationService.setOrgAccessToken(org_id, integration_id, data)
          .then(() => {
            this.$store.dispatch("ui/hideLoading")
            this.$router.replace(next)
          })
          .catch((err) => {
            this.$store.dispatch("ui/hideLoading")
            this.error = err.response.data.message
            this.error_description = err.response.data.description
            this.show_auth_error = true
          })
      } else {
        this.$store.dispatch("ui/hideLoading")
        this.error = this.$route.query.error
        this.error_description = this.$route.query.error_description
        if (this.$route.params.name == "outlook") {
          this.error = new URLSearchParams(window.location.hash.replace("#", "?")).get("error")
          this.error_description = new URLSearchParams(window.location.hash.replace("#", "?")).get("error_description")
        }
        //there is an error happens we could not get the auth code from salesforce
        if (utils.isNotEmpty(this.$route.query.error) && !this.error) {
          this.error = this.$route.query.error
          this.error_description = this.$route.query?.error_description
        }
        if (!this.error) {
          this.error = this.$t("Something went wrong!")
          this.error_description = this.$t("Please try again")
        }
        this.show_auth_error = true
      }
    } else {
      this.$store.dispatch("ui/hideLoading")
      this.$router.push({
        path: "/login",
        query: { next: `${this.$$route.fullpath}&instance_url${document.referrer}` }
      })
    }
  }
}
</script>
